import api from '../apiService';
import { API_ROUTES } from '../constants';

export interface TriggerEntity {
  entityType: string;
  entityName: string;
}

export interface TriggerEvent {
  eventId: string;
  eventName: string;
}

export interface ActionCatalogDto {
  actionId: string;
  actionName: string;
  entityType: string;
  actionType: string;
  actionKey: string;
  description: string;
  integration: string;
}

export interface ConditionCatalogDto {
  fieldKey: string;
  fieldType: string;
  operators: string[];
}

const API_BASE_URL = API_ROUTES.CATALOG;

export const catalogService = {
  getEntities: async () => {
    const response = await api.get<TriggerEntity[]>(API_BASE_URL);
    return response.data;
  },

  getEvents: async (entityId: string) => {
    const response = await api.get<TriggerEvent[]>(`${API_BASE_URL}/${entityId}/events`);
    return response.data;
  },

  getActions: async (entityId: string) => {
    const response = await api.get<ActionCatalogDto[]>(`${API_BASE_URL}/${entityId}/actions`);
    return response.data;
  },

  getConditions: async (entityId: string) => {
    const response = await api.get<ConditionCatalogDto[]>(`${API_BASE_URL}/${entityId}/conditions`);
    return response.data;
  },
};
